import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function OrganicLasersUseCase() {
  return (
    <>
    <section
      id="organic-lasers"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">

        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Organic Lasers
          </h1>
<p className="text-slate-300 space-y-2">
  Organic lasers are light sources based on organic molecules that can amplify light through stimulated emission. 
  These materials enable compact, tunable, and solution-processable laser devices that operate across the visible spectrum. 
  Organic solid-state lasers (OSSLs) typically use doped polymers or crystalline films as gain media and require careful 
  engineering of molecular structure, packing, and photostability. While challenges remain in achieving continuous-wave 
  operation and device longevity, organic lasers hold promise for applications in biosensing, displays, photonic circuits, 
  and spectroscopy.

  <br /><br />

  Key material requirements include strong fluorescence quantum yields, narrow emission bandwidths<sup>[1]</sup>, 
  high photostability, and appropriate excited-state lifetimes. Molecular design must also consider aggregation-induced 
  quenching and waveguide compatibility for device integration.
</p>
        </div>

        {/* How Apoello Helps */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
          <ul className="list-disc list-inside text-slate-300 space-y-2">
            <li>
              Filter large molecule libraries by oscillator strength, fluorescence lifetime, and emission wavelength.
            </li>
            <li>
              Screen candidates with high photostability and minimal non-radiative losses.
            </li>
            <li>
              Evaluate excited-state properties, transition dipoles, and vibrational reorganisation energies.
            </li>
            <li>
              Identify aggregation-resistant molecules suitable for thin-film or doped-polymer configurations.
            </li>
          </ul>
        </div>

        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why It Matters</h2>
          <p className="text-slate-300 max-w-3xl">
            Organic lasers represent a frontier technology in photonics, but progress is slowed by material limitations and 
            synthesis bottlenecks. DiaDEM™ accelerates innovation by enabling rapid digital screening of laser candidates 
            before lab work begins — unlocking new classes of gain media and reducing trial-and-error development.
          </p>
        </div>

{/* References */}
<div className="space-y-4 pt-10">
  <h2 className="text-2xl font-semibold text-orange-300">References from our group</h2>
  <ol className="list-decimal list-inside text-slate-400 space-y-1 text-sm">
    <li>
      Xie, X. & Troisi, A. <i>Identification via Virtual Screening of Emissive Molecules with a Small Exciton-Vibration Coupling for High Color Purity and Potential Large Exciton Delocalization</i>, J. Phys. Chem. Lett. (2023).{" "}
      <a
        href="https://doi.org/10.1021/acs.jpclett.3c00749"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#F89B3F] underline"
      >
        Link ↗
      </a>
    </li>
  </ol>
</div>

        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>

      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
